<template>
  <Card
    noBorder
  >
    <SectionHeader
      title="Default User State for User Creation"
    >
      Users will default to one of the following user states based on their creation method.
      <Link
        :href="$options.kbUrl"
        isExternal
        target="_blank"
        :text="$options.linkText"
      />
      <ul :class="$style.list">
        <li>
          <strong>Staged</strong>: Easily identify users who still need to be onboarded.
          Pre-assign all the resources and policies new users will need on their start dates
          without granting access.
        </li>
        <li>
          <strong>Active</strong>: Immediately provision a user account and enable a user's
          access to assigned resources and policies.
        </li>
      </ul>
      <NotificationInPage
        :class="$style.notification"
        :notification="$options.notification"
      />
    </SectionHeader>
    <template v-slot:body>
      <FieldsUserState
        v-model="newSystemUserStateDefaults"
      />
    </template>
  </Card>
</template>

<script>

import {
  Card,
  Link,
  NotificationInPage,
  Types,
} from '@jumpcloud/ui-components';
import FieldsUserState from 'client/systemusers/SystemUserItemTable/UserManagement/FieldsUserState.vue';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import SectionHeader from 'client/settings/components/SectionHeader.vue';

const kbUrl = KbArticleUrls.managingUserStates;
const linkText = 'Learn more';

const { NotificationConfig } = Types;
const notification = NotificationConfig({
  isMarkdown: true,
  message: '**Pro Tip:** Create users in a staged state to set up accounts before an employee\'s start date',
  type: 'informational',
});

export default {
  name: 'SectionUserState',

  components: {
    Card,
    FieldsUserState,
    Link,
    NotificationInPage,
    SectionHeader,
  },

  notification,

  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    newSystemUserStateDefaults: {
      get() {
        return this.value.newSystemUserStateDefaults || {};
      },
      set(newValue) {
        this.$emit('input', {
          ...this.value,
          newSystemUserStateDefaults: newValue,
        });
      },
    },
  },

  kbUrl,
  linkText,
};
</script>

<style module scoped>
.list {
  margin: 0;
}

.notification {
  margin-top: var(--jc-spacer-small);
}
</style>
